import ScenarioPage from './ScenarioContainer'

export default ScenarioPage
